import { api } from "@/lib/api";

let _cache = null;
let _promise = null;

/** Fetch blog-display settings (public GET). Module-level memo so every blog
 * page mount doesn't re-hit the network. Admin panel calls `invalidate()` after saving. */
export async function loadBlogDisplaySettings() {
  if (_cache) return _cache;
  if (!_promise) {
    _promise = api.get("/site-settings/blog-display")
      .then(r => { _cache = r.data; return r.data; })
      .catch(() => ({ toc_label: "Blog Contents" }));
  }
  return _promise;
}

export function invalidateBlogDisplayCache() { _cache = null; _promise = null; }
